exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// /var/www/smartbuy.ru/~/babel-runtime/~/core-js/library/modules/_wks-ext.js
// module id = 589
// module chunks = 22 40